import { motion } from "motion/react";
import { springs } from "@/lib/motion/tokens";
import { hapticService } from "@/lib/capacitor";
import { cn } from "@/lib/utils";
import type { Mood } from "@andrum/schemas";

const moods: { value: Mood; label: string; emoji: string }[] = [
  { value: 0, label: "Mycket tungt", emoji: "😔" },
  { value: 1, label: "Tungt", emoji: "😕" },
  { value: 2, label: "Neutralt", emoji: "😐" },
  { value: 3, label: "Ganska bra", emoji: "🙂" },
  { value: 4, label: "Mycket bra", emoji: "😊" },
];

interface MoodSelectorProps {
  value: Mood | null;
  onChange: (mood: Mood) => void;
}

export function MoodSelector({ value, onChange }: MoodSelectorProps) {
  return (
    <div
      className="grid grid-cols-5 gap-2 sm:gap-2.5"
      role="radiogroup"
      aria-label="Hur känns det just nu?"
    >
      {moods.map((mood) => {
        const selected = value === mood.value;
        return (
          <motion.button
            key={mood.value}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={mood.label}
            whileTap={{ scale: 0.94 }}
            transition={springs.responsive}
            onClick={() => {
              void hapticService.selection();
              onChange(mood.value);
            }}
            className={cn(
              "flex min-h-[4.75rem] flex-col items-center justify-center gap-2 rounded-2xl px-1 py-3 transition-colors",
              selected
                ? "bg-primary-soft text-primary shadow-sm ring-2 ring-primary/25"
                : "bg-surface-muted text-foreground-muted hover:bg-surface"
            )}
          >
            <span className="text-[1.65rem] leading-none" aria-hidden>
              {mood.emoji}
            </span>
            <span className="px-0.5 text-center text-[10px] font-medium leading-tight sm:text-[11px]">
              {mood.label}
            </span>
          </motion.button>
        );
      })}
    </div>
  );
}
